import React from 'react';
import {Link} from 'react-router-dom';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__12} from '@homeaway/svg-defs/lib/defs/CHEVRON_RIGHT__12';
import AspectRatioImage from '../../components/AspectRatioImage/AspectRatioImage';
import {HomeRouteContext} from '../../utils/context';
import './FeaturedCallOut.less';

const FeaturedCallOut = ({
    title,
    subtitle,
    image,
    link,
    parent,
    overview,
    withButton,
}) => {
    return (
        <div className="FeaturedCallOut">
            <AspectRatioImage
                {...image}
                className="FeaturedCallOut__col"
                linkComponent={(child) => <Link to={link}>{child}</Link>}
            />
            <div className="FeaturedCallOut__col">
                <div className="FeaturedCallOut__text-block">
                    <Link to={link}>
                        <h2 className="FeaturedCallOut__headline">
                            <span className="heading-hover-bg">{title}</span>
                        </h2>
                    </Link>
                    {subtitle && (
                        <p>
                            <HomeRouteContext.Consumer>
                                {(homeRoute) => (
                                    <Link to={homeRoute + parent.path}>
                                        <strong>{subtitle}</strong>
                                    </Link>
                                )}
                            </HomeRouteContext.Consumer>
                        </p>
                    )}
                    <p className="FeaturedCallOut__overview">{overview}</p>
                    {withButton && (
                        <Link
                            to={link}
                            className="FeaturedCallOut__link-button"
                        >
                            <SVGIcon markup={CHEVRON_RIGHT__12} />
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FeaturedCallOut;
